<template>
  <div style="text-align: center;margin: 20px auto;width: auto; min-height: calc(100vh - 183px); padding: 18px 0;">
    <div class="contentHeight">
      <h3>{{ details.title }}</h3>
      <p class="readingTime">
        <span>发布时间：{{ details.publishDate }}</span>
        <span
            class="belongTo">{{ details.articleType === 1 ? '新闻咨询' : details.articleType === 2 ? '每日研究' : '公益科普' }}</span>

        <el-button @click="toDoctor" size="small" type="primary">发布人</el-button>
        <!--<span class="belongTo" v-if="details.typeName">{{details.typeName}}</span>-->
      </p>

      <el-divider content-position="center">缩略图</el-divider>
      <div v-if="details.thumbnailPath"
           :style="'background: url('+details.thumbnailPath+') no-repeat;height: 330px;backgroundSize: 80%;backgroundPosition: center;'"></div>
      <el-divider content-position="center">摘要</el-divider>
      <div class="narrate">{{ details.summary }}</div>
      <el-divider content-position="center">内容</el-divider>
      <div class="narrate" v-html="details.pageContent"></div>

    </div>
  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "historyArticle",
  data() {
    return {
      id: this.$route.params.id,
      details: {},
    }
  },
  mounted() {
    this.$ajax.get(commonjs.api.event.edit.historyArticle.replace("{id}", this.id)).then((res) => {
      if (res.data.status === 'success') {
        this.details = res.data.data;
      }
    });
  },
  methods: {
    toDoctor() {
      this.$router.push({path: '../../doctor/detail/' + this.details.doctorId})
    }
  }
}
</script>

<style scoped lang="scss">
.contentHeight {
  min-height: calc(100vh - 350px);
}


.readingTime, .narrate {
  font-size: 13px;
  color: #666666;
  margin: 20px 0;
}

.readingTime {
  width: 50%;
  margin: 20px auto;

  span {
    margin-right: 10%;

    &:last-child {
      margin-right: 0;
    }

    &.belongTo {
      display: inline-block;
      width: auto;
      background: rgba(148, 157, 223, 0.2);
      padding: 0 13px;
      height: 20px;
      line-height: 20px;
    }
  }
}

.narrate {
  text-align: justify;
  line-height: 2;
  text-indent: 2em;

  img {
    max-width: 100% !important;
    margin: 10px 0 !important;
  }
}
</style>